import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { Component } from "react";

import { CircularProgress } from "@mui/material";
import Progress from "../graphs/Progress";
import {ChevronLeftRounded} from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CardContent } from "@mui/material";
import { IconButton,Link } from "@mui/material";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { Divider } from "@mui/material";
import { Bar, BarChart, Cell, ResponsiveContainer, XAxis } from "recharts";
import wyzrTheme from "../../../styles/customTheme";
import { Paper } from "@mui/material";
import theme from "../../../styles/customTheme";
import EditBudgetUpcomingTransaction from "../EditBudgetUpcomingTransaction";
import EditBudgetPastTransaction from "../EditBudgetPastTransaction";
import { getURLBase, updateParentHeight } from "../../../utils/helperFns";
import EditBudget from "../../../components/ui-components/budget-tab/EditBudget";
import LoaderBlock from "../LoaderBlock";
import axios from "axios";
import { updateHeightAfterContentUpdate } from "../../../utils/helperFns";
import { Button } from "@material-ui/core";
import TransactionListForBudget from "../TransactionListForBudget";
import NoMoneyIcon from "../../../images/no-money.png";
export class BudgetCategory extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/categorybreakdown";
        this.state = {
            isReady: false,
            monthDataReady: false,
            categoryName: null,
            categoryId : null,
            currentMonthName : null,
            showUpcomingEdit: false,
            showPastEdit: false,
            currentMonthKey: null,
            showEditBudget: false
        };
    }

    static getDerivedStateFromProps(props, state) {
        console.log("BudgetCategory getDerivedStateFromProps - ", props);
        return {categoryName: props?.categoryName, categoryId: props?.categoryId, unit: props?.unit};
      }

    componentDidMount() {
        console.log("BudgetCategory componentDidMount");

        this.getData(this.state.categoryName, this.state.categoryId).then((response) => {
            this.setStateUI(response.data.body.pieData,this.state.unit);
        });
    }

    processBarGraphData(categoryDetailsobject, unit){

    }

    getData(catName,catId){
        if(!this.state.isReady){
        return axios.post(this.url, { gid: this.props.gid, category:catName, categoryid:catId }).then((response) => {
          console.log("BudgetCategory getData RESPONSE --", response.data.body);
            return response;
        }).catch(err => {
                console.log("BudgetCategory getData ERROR --", err);
                return err;
        });
      }
    }

    setStateUI(categoryDetailsObj,unit){
        var tempState = this.state;
        tempState.categoryDetailsArray = categoryDetailsObj;

        if(Object.keys(tempState.categoryDetailsArray).length !== 0){
            tempState.noDataAvailable = false;
            console.log("Category Data Exists");
            
            for (const [key, value] of Object.entries(tempState.categoryDetailsArray)) {
                //console.log(`${key}: ${value}`);
                if(value.name === this.props.monthName){
                    tempState.currentMonthKey = parseInt(key);
                    break;
                }
                tempState.currentMonthKey = null;
              }
            //set BarGraph Data
            tempState.barGraphData = this.getBarGraphData(tempState.categoryDetailsArray,unit);

        }
        else{
            //code to show blank widget
            tempState.noDataAvailable = true; 
            console.log("Category Data does not exist", tempState);
        }

        //set UI ready
        tempState.isReady = true;
        tempState.monthDataReady = true;
        tempState.currentMonthName = this.props.monthName;
        this.setState(tempState, () => {
            console.log("BudgetCategory setStateUI - ", this.state);
        });
    }

    getBarGraphData(categoryDetailsArray,unit){
        var barGraphData = [];
        Object.values(categoryDetailsArray).forEach((monthCategory) => {
            if(unit === "-1" || unit === "0"){
                barGraphData.push({name: monthCategory.name, value: monthCategory.total});
            }
            else{
                barGraphData.push({name: monthCategory.name, value: monthCategory.total_coo});
            }
        });
        return barGraphData;
    }

      componentDidUpdate(prevProps, prevState) {
        if(prevState.categoryName !== this.state.categoryName) {
            this.setState({isReady:false}, () => {
                this.getData(this.state.categoryName, this.state.categoryId).then((response) => {
                    this.setStateUI(response.data.body.pieData);
                });
        });
          console.log("BudgetCategory componentDidMount executed");
        }
      }

      componentDidCatch(error, errorInfo) {
        console.log("componentDidCatch - ",error, errorInfo);
    }

    handleBarClick = (data, index) => {
        console.log("data onclick - ", data, index);
            this.setState({currentMonthKey : index,currentMonthName: data.name})
    };

    loadDataformonth = (month) => {
        var s = this.state;
        s.monthDataReady = false;
        this.setState({ monthDataReady : false } , () => {

        });

        setTimeout(() => {
            var s = this.state;
            s.monthDataReady = false;
            this.setState({ s });
        }, 500);

    };

    toggleEditBudget = () => {
        if (this.state.isReady) {

            var show = this.state.showEditBudget;
            show = !show
            this.setState({ showEditBudget: show },
                () => {
                    updateParentHeight("child_BudgetCategory", "child_EditBudget", this.state.showEditBudget, "parent_BudgetBreakdown");
                });
            }
    }

    openUpcomingTransactionEdit = (transaction) => {
        this.setState({
            showUpcomingEdit: true,
            currentUpcomingEdit: transaction
        },
            () => {
                updateParentHeight("child_BudgetCategory", "child_EditBudgetUpcomingTransaction", this.state.showUpcomingEdit, "parent_BudgetBreakdown")
            });
    }

    closeUpcomingTransactionEdit = () => {
        this.setState({ showUpcomingEdit: false },
            () => {
                updateParentHeight("child_BudgetCategory", "child_EditBudgetUpcomingTransaction", this.state.showUpcomingEdit, "parent_BudgetBreakdown")
            });
    }

    openPastTransactionEdit = (transaction) => {
        this.setState({
            showPastEdit: true,
            currentPastEdit: transaction
        }, () => {
            updateParentHeight("child_BudgetCategory", "child_EditBudgetPastTransaction", this.state.showPastEdit, "parent_BudgetBreakdown")
        })
    }

    closePastTransactionEdit = () => {
        this.setState({ showPastEdit: false },
            () => {
                updateParentHeight("child_BudgetCategory", "child_EditBudgetPastTransaction", this.state.showPastEdit, "parent_BudgetBreakdown")
            });
    }

    CustomizedLabel = ({ x, y, name, height, value, width, index }, unit) => {
        //console.log("CustomizedLabel - ", props);
        return (
            <>
                <text x={x + width / 2} y={y-6} fontSize="0.9rem" fontWeight={this.state.activeIndex === index ? 800 : 500} dominantBaseline={value > 0 ? "text-after-edge" : "auto"} textAnchor="middle">
                  { unit === "-1" || unit === "0"? '£ ':null}
                   { unit === "-1" || unit === "0"? value.toFixed(2): unit === "1"?value.toFixed(1): value}
                   { unit === "1"?' kg':null}
                   </text>
            </>
        )
    };

    render() {
        return (
            <Box className="popup" id="child_BudgetCategory">
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props?.toggleHandler}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <CardContent sx={{ p: 0 }}>
                    <Box className="popupHeader">
                        <Typography variant="h4" align="center" gutterBottom>{this.props?.categoryName}</Typography>
                        <Divider />
                    </Box>
                    <Box className="popupBody" pt={{ xs: 6, sm: 0 }}>
                        {
                            !this.state.noDataAvailable ?
                            <Grid container maxWidth="sm" marginX="auto" marginBottom={4}>
                            <Grid width={"100%"} padding={"1rem"}>
                                <Paper variant="outlined" sx={{ marginTop: 2 }}>
                                    <CardContent>
                                        {this.state.isReady ? (
                                            <ResponsiveContainer
                                            width="100%"
                                                height={280}
                                                className="flex-center-all"
                                                sx={{ flexDirection: "column", marginTop: "15px" }}
                                            >
                                                <BarChart data={this.state.barGraphData}>
                                                    <XAxis dataKey="name" fontWeight={700} />
                                                    <Bar
                                                        dataKey="value"
                                                        fill="#8884d8"
                                                        onClick={this.handleBarClick}
                                                        barSize={20}
                                                        minPointSize={5}
                                                        label={($event) => this.CustomizedLabel($event, this.state.unit)}
                                                        radius={[10, 10, 0, 0]}
                                                    >
                                                        {this.state.isReady && this.state.barGraphData.map((entry, index) => (
                                                            <Cell
                                                                cursor="pointer"
                                                                fill={index ===  this.state.currentMonthKey ? wyzrTheme.palette.primary.light : wyzrTheme.palette.error.main}
                                                                key={`cell-${index}`}
                                                            />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    minHeight: "20vh",
                                                }}
                                            >
                                                <CircularProgress color="success" />
                                            </Box>
                                        )}
                                    </CardContent>
                                </Paper>

                                {this.state.monthDataReady ? (
                                     this.state.currentMonthKey != null ? 
                                    <Box width={"100%"}>
                                        <Paper variant="outlined" sx={{ marginTop: 3 }}>
                                            <CardContent className="cardOverflowScroll">
                                            <TransactionListForBudget
                                                    heading="Upcoming committed transactions"
                                                    categoryName={this.state.categoryName}
                                                    noDataMessage={"No upcoming transactions found for " + this.state.currentMonthName}
                                                    transactionList={this.state.isReady && this.state.categoryDetailsArray[this.state.currentMonthKey].committed_upcoming}
                                                    handleClick={this.openUpcomingTransactionEdit}
                                                    prefix={this.state.unit === "1"?"kg":"£"}
                                                />
                                               
                                            </CardContent>
                                        </Paper>
                                        <Paper variant="outlined" sx={{ marginTop: 3 }}>
                                            <CardContent className="cardOverflowScroll">
                                            <TransactionListForBudget
                                                    heading="Past transactions"
                                                    categoryName={this.state.categoryName}
                                                    noDataMessage={"No past transactions found for " + this.state.currentMonthName}
                                                    transactionList={this.state.isReady && this.state.categoryDetailsArray[this.state.currentMonthKey].past_transactions}
                                                    handleClick={this.openPastTransactionEdit}
                                                    prefix={this.state.unit === "1"?"kg":"£"}
                                                />
                                            </CardContent>
                                        </Paper>

                                        <Paper variant="outlined" sx={{ marginTop: 3, paddingBottom:3 }}>
                                            <CardContent>
                                                <Stack direction="row" marginBottom={1} gap={1.5}>
                                                    <Typography variant="h6">
                                                        Committed Spends
                                                    </Typography>

                                                    <Stack direction={"row"}>
                                                        <Typography variant={"body1"} fontWeight={600} color={theme.palette.grey[600]} mr={1}>
                                                            budget
                                                        </Typography>

                                                        <Typography variant={"body1"} fontWeight={600} display="flex" justifyContent={"end"} flexDirection={this.state.unit === "1" ? "row" : "row-reverse"} color={theme.palette.grey[600]}>
                                                            <span>
                                                                {
                                                                    this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends.length ?
                                                                        this.state.unit === "1" ? this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0]?.budget_co2 : this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0]?.budget : null
                                                                }
                                                            </span>
                                                            <span>
                                                                {this.state.unit === "1" ? " kg" : " £"}
                                                            </span>
                                                        </Typography>
                                                    </Stack>
                                                </Stack>

                                                {this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends.length ? 
                                                 <Progress
                                                 sx={{ flexGrow: 1, marginRight: "1rem" }}
                                                 prefix={this.state.unit === "-1" ? '£ ' : ' '}
                                                 suffix={this.state.unit === "0" ? '%' : this.state.unit === "1" ? ' kg' : ' '}
                                                 width="100%"
                                                 fontWeight={800}
                                                 startText="spent"
                                                 endText="remaining"
                                                 startNumber={this.state.unit === "0" ?
                                                     parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_pct * 100).toFixed(0)) :
                                                     this.state.unit === "-1" ? parseFloat(this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent.toFixed(2)) :
                                                         parseFloat(this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_co2.toFixed(1))}
                                                 endNumber={this.state.unit === "0" ? parseFloat((1 - this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_pct) * 100).toFixed(0) :
                                                     this.state.unit === "-1" ? parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].budget - this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent).toFixed(2)) :
                                                         parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].budget_co2 - this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_co2).toFixed(1))}
                                                 color={
                                                     this.state.unit === "-1" ?
                                                         (this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_pct > 1 ? theme.palette.error.dark : theme.palette.error.main) :
                                                         (this.state.unit === "-1") ? (this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent > this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].budget) ? theme.palette.error.dark : theme.palette.error.main :
                                                             (this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].spent_co2 > this.state.categoryDetailsArray[this.state.currentMonthKey].committed_spends[0].budget_co2) ? theme.palette.error.dark : theme.palette.error.main
                                                 }
                                                 showAsPercentage={this.state.unit === "0" ? true : false}
                                             /> : 
                                                <Typography variant="body1" color={theme.palette.grey[600]}> 
                                                    No data available for commited spends
                                                </Typography>
                                            }
                                               

                                            </CardContent>


                                            <CardContent>
                                                <Stack direction="row" marginBottom={1} gap={1.5}>
                                                    <Typography variant="h6">
                                                        Miscellaneous Spends
                                                    </Typography>

                                                    <Stack direction={"row"}>
                                                        <Typography variant={"body1"} fontWeight={600} color={theme.palette.grey[600]} mr={1}>
                                                            budget
                                                        </Typography>

                                                        <Typography variant={"body1"} fontWeight={600} display="flex" justifyContent={"end"} flexDirection={this.state.unit === "1" ? "row" : "row-reverse"} color={theme.palette.grey[600]}>
                                                            <span>
                                                                {
                                                                    this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends.length ?
                                                                        this.state.unit === "1" ? this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget_co2 : this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget : null
                                                                }
                                                            </span>
                                                            <span>
                                                                {this.state.unit === "1" ? " kg" : " £"}
                                                            </span>
                                                        </Typography>
                                                    </Stack>
                                                </Stack>

                                                { 
                                                this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends.length ?
                                                <Progress
                                                    sx={{ flexGrow: 1, marginRight: "1rem" }}
                                                    prefix={this.state.unit === "-1" ? '£ ' : ' '}
                                                    suffix={this.state.unit === "0" ? '%' : this.state.unit === "1" ? ' kg' : ' '}
                                                    width="100%"
                                                    fontWeight={800}
                                                    startText="spent"
                                                    endText="remaining"
                                                    startNumber={this.state.unit === "0" ?
                                                        parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_pct * 100).toFixed(0)) :
                                                        this.state.unit === "-1" ? parseFloat(this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent.toFixed(2)) :
                                                            parseFloat(this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_co2.toFixed(1))}
                                                    endNumber={this.state.unit === "0" ? parseFloat((1 - this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_pct) * 100).toFixed(0) :
                                                        this.state.unit === "-1" ? parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget - this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent).toFixed(2)) :
                                                            parseFloat((this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget_co2 - this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_co2).toFixed(1))}
                                                    color={
                                                        this.state.unit === "-1" ?
                                                            (this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_pct > 1 ? theme.palette.error.dark : theme.palette.error.main) :
                                                            (this.state.unit === "-1") ? (this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent > this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget) ? theme.palette.error.dark : theme.palette.error.main :
                                                                (this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].spent_co2 > this.state.categoryDetailsArray[this.state.currentMonthKey].noncommitted_spends[0].budget_co2) ? theme.palette.error.dark : theme.palette.error.main
                                                    }
                                                    showAsPercentage={this.state.unit === "0" ? true : false}
                                                /> : <Typography variant="body1" color={theme.palette.grey[600]}> 
                                                No data available for commited spends
                                            </Typography>}

                                            </CardContent>
                                        </Paper>                                       
                                    </Box> :
                                    <Paper variant={"outlined"} sx={{marginTop:4}}>
                                        <Box px={2} py={10}>
                                            <Typography align="center" color={theme.palette.grey[600]} variant="h6">
                                                No data available for {this.state.currentMonthName}. Please click the any bar to view data for its corresponding month.
                                            </Typography>
                                        </Box>
                                    </Paper>
                                ): <LoaderBlock /> }
                            </Grid>
                            </Grid> :
                            
                            <Box my={6} mx={2}>
                            <Paper variant={"outlined"}>
                                <Stack py={9} px={2} flexDirection={"column"} gap={3} justifyContent={"center"} alignItems={"center"}>
                                        <img src={NoMoneyIcon} width={75} alt="No data available" style={{opacity:0.25}} />

                                        <Typography variant="h6" color={theme.palette.grey[500]}>
                                            No data available for {this.state.categoryName}.
                                        </Typography>

                                        <Button
                                        component={Link}
                                        variant="outlined"
                                        fontWeight="700"
                                        startIcon={<ChevronLeftRounded colorprimary />}
                                        onClick={this.props?.toggleHandler}>
                                        Go Back
                                        </Button>
                                </Stack>
                            </Paper>
                            </Box>
                        }
                        
                    </Box>
                    { updateHeightAfterContentUpdate("parent_BudgetBreakdown", "child_BudgetCategory")}
                </CardContent>

                {this.state.showUpcomingEdit ?
                    <EditBudgetUpcomingTransaction
                    category= {this.state.categoryName}
                    subCategory= {this.state.categoryName}
                        transaction={this.state.currentUpcomingEdit}
                        toggleHandler={this.closeUpcomingTransactionEdit}
                        unit={this.state.unit}
                    ></EditBudgetUpcomingTransaction> : null}

                {this.state.showPastEdit ?
                    <EditBudgetPastTransaction
                        category= {this.state.categoryName}
                        subCategory= {this.state.categoryName}
                        transaction={this.state.currentPastEdit}
                        toggleHandler={this.closePastTransactionEdit}
                    ></EditBudgetPastTransaction> : null}

                {this.state.showEditBudget ?
                    <EditBudget
                        toggleHandler={this.toggleEditBudget}
                    ></EditBudget> : null}
            </Box>
        );
    }
}

export default BudgetCategory;





